export default class WpetService {
    constructor() {
        WpetService.initWpetLoader()
    }

    static initWpetLoader() {
        $(document).on('wp-etourisme-v3/form/submit', (ev, triggerData) => {
            $('body').addClass('is-loading')
        })

        $(document).on('wp-etourisme-v3/list/update', (ev, triggerData) => {
            $('body').removeClass('is-loading')
        })
    }
}
